import { useQuery } from '@tanstack/react-query';
import roleLandingPagesService, {
  type MyRoleLandingPage,
  type RoleLandingPagesResponse,
} from '../../services/roleLandingPagesService';

export const roleLandingPagesQueryKey = (pharmacyId?: string | null) =>
  ['role-landing-pages', pharmacyId] as const;

export const myRoleLandingPageQueryKey = (pharmacyId?: string | null) =>
  ['role-landing-pages', pharmacyId, 'mine'] as const;

/** PRX-124 — every role's landing page at a pharmacy (admin panel). */
export function useRoleLandingPages(pharmacyId?: string | null, enabled = true) {
  return useQuery<RoleLandingPagesResponse>({
    queryKey: roleLandingPagesQueryKey(pharmacyId),
    queryFn: () => roleLandingPagesService.get(pharmacyId as string),
    enabled: enabled && !!pharmacyId,
  });
}

/** PRX-124 — the signed-in user's role landing page at a pharmacy (sign-in redirect). */
export function useMyRoleLandingPage(pharmacyId?: string | null, enabled = true) {
  return useQuery<MyRoleLandingPage>({
    queryKey: myRoleLandingPageQueryKey(pharmacyId),
    queryFn: () => roleLandingPagesService.mine(pharmacyId as string),
    enabled: enabled && !!pharmacyId,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
